import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'
import DownloadService from '@/utils/download'

const state = {
  list: {
    loading: false,
    totalItems: 0,
    rowsPerPage: 20,
    headers: [
      { text: 'グループ名', align: 'left', value: 'name' },
      { text: 'タグ名', align: 'left', value: 'tag' },
      { text: '件数', align: 'left', value: 'count' },
      { text: '登録日', align: 'left', value: 'created' },
      { text: '公開設定', align: 'left', value: 'publish_setting' },
      { text: '作成者', align: 'left', value: 'user_name' },
      { text: '分析区分', align: 'left', value: 'pos_flag_display' },
      { text: '編集', align: 'center', value: '', type: 'edit', sortable: false },
      { text: 'ダウンロード', align: 'center', value: '', type: 'download', sortable: false }
    ],
    items: []
  },
  searchCondition: {
    freeword: ''
  },
  message: {
    content: '',
    type: ''
  }
}

const actions = {
  /**
   * groupデータ取得
   */
  async getGroupList ({ state, commit }, { pageNo, rowsPerPage, sortField, sortType, freeword }) {
    this.dispatch('loading/loadingPagePlus')
    commit('setListLoading', true)
    commit('setSearchCondition', {
      freeword: freeword
    })
    const response = await ApiManager.request('ProductGroup').productGroupList(
      pageNo,
      rowsPerPage,
      sortField,
      sortType,
      freeword
    )
    const message = {
      type: 'success',
      content: ''
    }
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setList', response.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      message.type = 'error'
      message.content = response.data.data.message
    }
    commit('setMessage', message)
    this.dispatch('loading/loadingPageMinus')
  },

  /**
   * category group download
   */
  async download ({ state, commit }, id) {
    this.dispatch('loading/loadingPagePlus')
    const response = await DownloadService.download('product_group', 'csv', (config) => {
      return ApiManager.request('ProductGroup').productGroupDownload({ id: id }, config)
    })
    if (response) {
      commit('setMessage', { content: response.message, type: 'error' })
    }
    this.dispatch('loading/loadingPageMinus')
  },

  /**
   * category group delete
   */
  async deleteGroup ({ state, commit }, deleteIds) {
    this.dispatch('loading/loadingPagePlus')
    commit('setListLoading', true)
    const response = await ApiManager.request('ProductGroup').productGroupDelete(deleteIds)
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else {
      commit('setMessage', { content: response.data.data.message, type: 'error' })
      commit('setListLoading', false)
    }
    this.dispatch('loading/loadingPageMinus')
  }
}

const mutations = {
  setMessage (state, data) {
    state.message = data
  },
  setSearchCondition (state, data) {
    state.searchCondition = data
  },
  setListLoading (state, data) {
    // Listローディング状態
    state.list.loading = data
  },
  setList (state, data) {
    state.list.items = data.data
    state.list.totalItems = data.meta.count
    state.list.loading = false
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
